module.exports = __webpack_public_path__ + "img/IMG-20200901-WA0006.67cbd35c.jpg";